import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  asignPlantoVendor,
} from "../../redux/services/SubscriptionServices/Subscription.Services";
import { ActiveModuleList, ActiveModuleBySubscription } from "../../redux/services/moduleService/module.Services";

import { errorToast, successToast } from "../../Utils/toast";
import { closeModal } from "../../redux/features/modalSlice";
import { openModal } from "../../redux/features/modalSlice";
import { FaPlus } from "react-icons/fa";

function AssignPlan() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const modalState = useSelector((state) => state.modal);
  const [refetchPlans, setRefetchPlans] = useState(false);
  const subscription = location.state?.subscription;

  const [loading, setLoading] = useState(false);
  const [planLoading, setPlanLoading] = useState(false);
  const [planList, setPlanList] = useState([]);
  const [modules, setModules] = useState([]);
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    module_id: "",
    selectedPlans: {},
    payment_method: "cash",
    note: "",
  });

  useEffect(() => {
    if (modalState.isOpen && modalState.type === "add-custom-plan") {
      setRefetchPlans(true);
    }
  }, [modalState.isOpen, modalState.type]);

  useEffect(() => {
    if (!modalState.isOpen && refetchPlans) {
      if (form.module_id) fetchPlans(form.module_id);
      setRefetchPlans(false);
    }
  }, [modalState.isOpen, refetchPlans]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await ActiveModuleList();
        setModules(res?.data || []);
      } catch (error) {
        console.log("API error:", error);
      }
    };
    fetchData();
  }, []);

  const fetchPlans = async (moduleId) => {
    try {
      setPlanLoading(true);
      const payload = { module_id: moduleId };
      const res = await ActiveModuleBySubscription(payload);
      const list =
        (Array.isArray(res?.data) && res.data) ||
        (Array.isArray(res?.data?.data) && res.data.data) ||
        (Array.isArray(res) && res) ||
        [];
      setPlanList(list);
    } catch (error) {
      console.log(error);
      errorToast("Failed to load plans");
      setPlanList([]);
    } finally {
      setPlanLoading(false);
    }
  };

  const handleChange = (e, valueArg) => {
    let name, value;
    if (typeof e === "string") {
      name = e;
      value = valueArg;
    } else {
      name = e.target.name;
      value = e.target.value;
    }

    setErrors((prev) => ({ ...prev, [name]: "" }));

    // Module Change: Reset plans
    if (name === "module_id") {
      setForm((prev) => ({
        ...prev,
        module_id: value,
        selectedPlans: {},
      }));
      setPlanList([]);
      if (value) fetchPlans(value);
      return;
    }

    // ✅ Toggle Plan Selection (Add / Remove from object)
    // if (name === "toggle_plan") {
    //   const planId = valueArg.id;
    //   const planPrice = valueArg.price;

    //   setForm((prev) => {
    //     const newSelected = { ...prev.selectedPlans };
    //     if (newSelected[planId] !== undefined) {
    //       delete newSelected[planId]; // Uncheck
    //     } else {
    //       newSelected[planId] = planPrice; // Check & set default price
    //     }
    //     return { ...prev, selectedPlans: newSelected };
    //   });
    //   return;
    // }


    if (name === "toggle_plan") {
      const planId = valueArg.id;
      const planPrice = valueArg.price;

      setForm((prev) => {
        const alreadySelected = prev.selectedPlans[planId] !== undefined;
        // single select: agar same plan dobara click -> uncheck, warna sirf yahi plan select
        return {
          ...prev,
          selectedPlans: alreadySelected ? {} : { [planId]: planPrice },
        };
      });
      return;
    }

    // ✅ Change Specific Plan Amount
    if (name === "plan_amount") {
      setForm((prev) => ({
        ...prev,
        selectedPlans: {
          ...prev.selectedPlans,
          [valueArg.id]: value,
        },
      }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!subscription?.id) {
      return errorToast("Subscription ID missing. Please reload the page.");
    }

    const newErrors = {};
    const selectedPlanIds = Object.keys(form.selectedPlans);

    if (!form.module_id) newErrors.module_id = "Please select a service";
    if (selectedPlanIds.length === 0) newErrors.new_plan_id = "Please select at least one plan";

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return errorToast(Object.values(newErrors)[0]);
    }

    try {
      setLoading(true);

      // ✅ 2. Format Payload Exactly as Backend Validator Requires
      const payload = {
        vendor_id: subscription?.user_id,
        module_id: Number(form.module_id),
        plans: selectedPlanIds.map((planId) => ({
          plan_id: Number(planId),
          payment_amount: Number(form.selectedPlans[planId]),
          payment_method: form.payment_method,
        })),
        notes: form.note,
      };

      const res = await asignPlantoVendor(payload);
      successToast(res?.message || "Plan assigned successfully");

      dispatch(closeModal());
      navigate(-1);
    } catch (error) {
      const data = error?.response?.data;
      let msg = data?.message || "Failed to assign plan";
      if (data?.errors && typeof data.errors === "object") {
        const firstKey = Object.keys(data.errors)[0];
        if (firstKey && Array.isArray(data.errors[firstKey]) && data.errors[firstKey][0]) {
          msg = data.errors[firstKey][0];
        }
      }
      errorToast(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Assign Plan</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Assign Plan</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button className="add-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </div>
      <div className="main_page">
        <div className="card">
          <div className="card-body">
            {subscription ? (
              <div className="upgrade-vendor-card">
                <div className="upgrade-vendor-row">
                  <div className="upgrade-vendor-item">
                    <span className="upgrade-vendor-label">Vendor</span>
                    <span className="upgrade-vendor-value">
                      {subscription?.vendor?.name || subscription?.vendor?.mobile || subscription?.user_id || "-"}
                    </span>
                  </div>
                  <span className="upgrade-vendor-divider" />
                  <div className="upgrade-vendor-item">
                    <span className="upgrade-vendor-label">Name</span>
                    <span className="upgrade-vendor-value">
                      {subscription?.vendor?.name || subscription?.name || "-"}
                    </span>
                  </div>
                  <span className="upgrade-vendor-divider" />
                  <div className="upgrade-vendor-item">
                    <span className="upgrade-vendor-label">Mobile</span>
                    <span className="upgrade-vendor-value">
                      {subscription?.vendor?.mobile || subscription?.mobile || "-"}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="upgrade-vendor-error">
                Subscription data not available.
              </div>
            )}

            <form onSubmit={handleSubmit} className="upgrade-form">
              <div className="row">
                {/* Service / Module */}
                <div className="col-md-12 mb-3">
                  <label className="form-label fw-bold">
                    Service <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-control${errors.module_id ? " is-invalid" : ""}`}
                    name="module_id"
                    value={form.module_id}
                    onChange={handleChange}
                  >
                    <option value="">Select Service</option>
                    {modules.map((mod) => (
                      <option key={mod.id} value={mod.id}>
                        {mod.name}
                      </option>
                    ))}
                  </select>
                  {errors.module_id && (
                    <div className="invalid-feedback">{errors.module_id}</div>
                  )}
                </div>

                {/* Plan Cards */}
                <div className="col-md-12 mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <label className="form-label fw-bold mb-0">
                      Select Plan(s) <span className="text-danger">*</span>
                    </label>
                    <button
                      type="button"
                      className="btn btn-sm custom-plan-btn d-flex align-items-center gap-2 rounded-pill mb-3"
                      disabled={!form.module_id}
                      onClick={() =>
                        dispatch(
                          openModal({
                            type: "add-custom-plan",
                            title: "Add Custom Plan",
                            data: {
                              module_id: form.module_id,
                              vendor_id:
                                subscription?.user_id ||
                                subscription?.vendor_id ||
                                subscription?.vendor?.user_id ||
                                subscription?.vendor?.id,
                            },
                          })
                        )
                      }
                    >
                      <FaPlus size={12} />
                      Add Custom Plan
                    </button>
                  </div>

                  <div
                    className="row g-3"
                    style={{
                      padding: (planLoading || planList.length > 0 || form.module_id) ? "1rem" : "0",
                      border: (planLoading || planList.length > 0 || form.module_id) ? "1px solid #334155" : "none",
                      backgroundColor: (planLoading || planList.length > 0 || form.module_id) ? "#0f172a" : "transparent",
                      borderRadius: "10px"
                    }}
                  >
                    {planLoading ? (
                      <div className="col-12 d-flex flex-column align-items-center justify-content-center py-4 text-muted">
                        <div className="spinner-border spinner-border-sm text-primary mb-2" role="status"></div>
                        <span style={{ fontSize: "14px" }}>Loading plans...</span>
                      </div>
                    ) : !form.module_id ? (
                      <div className="col-12 d-flex align-items-center justify-content-center py-3 rounded"
                        style={{ border: "1px dashed #475569", backgroundColor: "rgba(30, 41, 59, 0.5)" }}>
                        <span style={{ color: "#94a3b8", fontSize: "14px" }}>
                          <i className="fa fa-info-circle me-2"></i>
                          Please select a service above to view plans.
                        </span>
                      </div>
                    ) : planList.length === 0 ? (
                      <div className="col-12 d-flex flex-column align-items-center justify-content-center py-5 rounded"
                        style={{ border: "1px dashed #475569", backgroundColor: "#1e293b" }}>
                        <h6 className="text-light mb-1" style={{ fontSize: "15px" }}>No plans available</h6>
                        <p className="text-muted small mb-0">Click on "+ Add Plan" to create a new one.</p>
                      </div>
                    ) : (
                      planList.map((plan) => {
                        // Check if plan is in selectedPlans object
                        const isSelected = form.selectedPlans[plan.id] !== undefined;
                        const currentAmount = isSelected ? form.selectedPlans[plan.id] : "";

                        return (
                          <div key={plan.id} className="col-md-6 col-lg-4">
                            <div
                              className="position-relative h-100 d-flex flex-column"
                              style={{
                                border: isSelected ? "2px solid #3b82f6" : "1px solid #334155",
                                backgroundColor: isSelected ? "rgba(59, 130, 246, 0.1)" : "#1e293b",
                                borderRadius: "12px",
                                padding: "16px",
                                transition: "all 0.2s ease",
                                boxShadow: isSelected ? "0 4px 12px rgba(59, 130, 246, 0.2)" : "0 2px 4px rgba(0,0,0,0.1)"
                              }}
                            >
                              {/* Checkbox area for selection */}
                              <label className="d-flex align-items-start w-100 mb-2" style={{ cursor: "pointer" }}>
                                <input
                                  type="checkbox"
                                  className="form-check-input mt-1 me-2"
                                  checked={isSelected}
                                  onChange={() => handleChange("toggle_plan", { id: plan.id, price: plan.price })}
                                />
                                <div>
                                  <h6 className="fw-bold mb-1" style={{ fontSize: "15px", color: isSelected ? "#60a5fa" : "#e2e8f0", lineHeight: "1.4" }}>
                                    {plan.name}
                                  </h6>
                                  {plan.badge_text && (
                                    <span className="badge bg-warning text-dark" style={{ fontSize: "10px", padding: "4px 8px" }}>
                                      {plan.badge_text}
                                    </span>
                                  )}
                                </div>
                              </label>

                              <div className="d-flex align-items-center mb-2 p-2 rounded" style={{ backgroundColor: isSelected ? "rgba(59,130,246,0.15)" : "#0f172a" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={isSelected ? "#60a5fa" : "#94a3b8"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                                <span style={{ fontSize: "13px", fontWeight: "600", color: isSelected ? "#e2e8f0" : "#cbd5e1" }}>
                                  {plan.ai_call_limit} AI Calls
                                </span>
                              </div>

                              <div className="mt-auto pt-2 border-top" style={{ borderColor: isSelected ? "rgba(59,130,246,0.3)" : "#334155" }}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  {plan.original_price && (
                                    <span className="text-muted text-decoration-line-through" style={{ fontSize: "12px" }}>
                                      ₹{plan.original_price}
                                    </span>
                                  )}
                                  <span className="fw-bold" style={{ fontSize: "16px", color: "#10b981" }}>
                                    Base: ₹{plan.price}
                                  </span>
                                </div>

                                {/* ✅ Editable Amount Input (Only if selected) */}
                                {isSelected && (
                                  <div>
                                    <label className="text-muted mb-1" style={{ fontSize: "11px" }}>Payment Amount (₹)</label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      name="plan_amount"
                                      value={currentAmount}
                                      onChange={(e) => handleChange("plan_amount", { id: plan.id, value: e.target.value })}
                                      style={{ backgroundColor: "#0f172a", color: "white", borderColor: "#475569" }}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                  {errors.new_plan_id && (
                    <div className="text-danger mt-2" style={{ fontSize: "13px" }}>
                      {errors.new_plan_id}
                    </div>
                  )}
                </div>

                {/* Payment Method */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Payment Method</label>
                  <select
                    className="form-control"
                    name="payment_method"
                    value={form.payment_method}
                    onChange={handleChange}
                  >
                    <option value="cash">Cash</option>
                    <option value="online">Online</option>
                    <option value="upi">UPI</option>
                    <option value="card">Card</option>
                  </select>
                </div>

                {/* Note */}
                <div className="col-md-12 mb-3">
                  <label className="form-label fw-bold">Note</label>
                  <textarea
                    rows={2}
                    className="form-control upgrade-note"
                    name="note"
                    placeholder="Enter Note"
                    value={form.note}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="upgrade-actions ms-2 mt-3">
                <button
                  type="submit"
                  className="add-btn"
                  disabled={loading || planLoading}
                >
                  {loading ? "Assigning..." : "Assign Plan"}
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => dispatch(closeModal())}
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssignPlan;